import * as sass from "./lists.module.scss"

const ActUl = ({ children }) => {
  return <ul className={sass.bookList}>{children}</ul>
}

export default ActUl
